module.exports = __webpack_public_path__ + "img/icon_14.7052181e.png";